import { createAction, props } from '@ngrx/store';
import { SignUpUser, User } from './auth.models';

export const authenticateUserPrecheck = createAction(
  '[Auth] PreAuthenticating User'
);

export const logoutUser = createAction(
  '[Auth] Logout User'
);

export const authenticateUser = createAction(
  '[Auth] Authenticating User',
  props<{username: string, password: string}>()
);

export const authenticateUserSuccess = createAction(
  '[Auth] Authenticating User Success',
  props<{ user: User }>()
);

export const authenticateUserFailure = createAction(
  '[Auth]  Authenticating User Failure',
  props<{ error: any }>()
);

export const signUpUser = createAction(
  '[Auth]  Sign Up User',
  props<{ userData: SignUpUser }>()
);

export const signUpUserSuccess = createAction(
  '[Auth]  Sign Up User Success',
  props<{ message: string, authState: string }>()
);

export const signUpUserFailure = createAction(
  '[Auth]  Sign Up User Failure',
  props<{ error: any }>()
);


export const authLogout = createAction(
  '[Auth]  Log out'
);
